import { render } from "./fieldImage.vue?vue&type=template&id=2a0fee85"
import script from "./fieldImage.vue?vue&type=script&lang=js"
export * from "./fieldImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__